export default 'M12 0a12 12 0 1 1 0 24 12 12 0 0 1 0-24m4.42 10.92a.52.52 0 0 0-.45-.8h-3.1l.9-5.62h-1.05l-5.14 8.58c-.21.35.04.8.45.8h3.1l-.9 5.62h1.05z';